import pricePayload from "@/payloads/price.json";
import refChangesPayload from "@/payloads/ref_changes.json";
import refFieldsPayload from "@/payloads/ref_fields.json";
import coraxEventsPayload from "@/payloads/corporate_actions_events.json";
import coraxEventsChangesPayload from "@/payloads/corporate_actions_events_changes.json";
import coraxReferencePayload from "@/payloads/corporate_actions_reference.json";
import coraxReferenceChangesPayload from "@/payloads/corporate_actions_reference_changes.json";

export default {
    onExportClick(){
      this.$refs.exportOverlay.opened = true
    }, 
    closeExportPopup(){
      this.$refs.exportOverlay.opened = false
    },
    onExportSubmit(){
      this.$refs.exportOverlay.opened = false
      let vals = document.getElementById("ex-tree").values
      let rics = []
      let issues = []
      let quotes = []
      for(let val of vals){
        let temp = val.split(",")
        rics.push(temp[0])
        issues.push(temp[1])
        quotes.push(temp[2])
      }
      this.exportQuotes = quotes.join("|")
      this.exportIssues = issues.join("|")
      let dataToggle = document.getElementById("change-data-toggle")
      let toggle = document.getElementById("export-toggle-btn")
      if(dataToggle.checked){
        if(toggle.checked){
          this.exportDeltaReference(rics.join("|"))
        }else{
          this.exportProcessedReference(rics.join("|"))
        }
      }else{
        if(toggle.checked){
          this.exportDeltaCoraxReference(issues.join("|"))
        }else{
          this.exportProcessedCoraxReference(issues.join("|"))
        }
      }
    },
    exportProcessedReference(rics){
      this.exportRefData = [];
      this.requestType = "exportProcessedReference"
      var payload = JSON.parse(JSON.stringify(refFieldsPayload))
      payload["dataConditions"]["conditions"][0]["fieldValue"] = rics
      var payload2 = JSON.parse(JSON.stringify(refChangesPayload))
      payload2["dataConditions"]["conditions"][0]["fieldValue"] = rics
      payload2["dataConditions"]["conditions"][1]["fieldValue"] = rics
      let date = document.getElementById("export-drpdwn").value
      if(date == "All"){
        payload["dateConditions"][0]["startDate"] = this.selectedDate
        payload["dateConditions"][0]["endDate"] = this.todayDate
        payload2["dateConditions"][0]["startDate"] = this.selectedDate
        payload2["dateConditions"][0]["endDate"] = this.todayDate
      }else{
        let d = new Date(date)
        let dateString =  d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
        payload["dateConditions"][0]["startDate"] = dateString
        payload["dateConditions"][0]["endDate"] = dateString
        payload2["dateConditions"][0]["startDate"] = dateString
        payload2["dateConditions"][0]["endDate"] = dateString
      }
      this.refPromise = 2
      Promise.all([this.postQueryExecution(payload), this.postQueryExecution(payload2)])
    },
    exportDeltaReference(rics){
      this.requestType = "exportDeltaReference"
      var payload = JSON.parse(JSON.stringify(refChangesPayload))
      payload["dataConditions"]["conditions"][0]["fieldValue"] = rics
      payload["dataConditions"]["conditions"][1]["fieldValue"] = rics
      let date = document.getElementById("export-drpdwn").value
      if(date == "All"){
        payload["dateConditions"][0]["startDate"] = this.selectedDate
        payload["dateConditions"][0]["endDate"] = this.todayDate
      }else{
        let d = new Date(date)
        let dateString =  d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
        payload["dateConditions"][0]["startDate"] = dateString
        payload["dateConditions"][0]["endDate"] = dateString
      }
      this.postQueryExecution(payload)
    },
    exportProcessedCoraxReference(issues){
      this.requestType = "exportProcessedCoraxReference"
      var payload = JSON.parse(JSON.stringify(coraxReferencePayload))
      payload["dataConditions"]["conditions"][0]["fieldValue"] = issues
      var payload2 = JSON.parse(JSON.stringify(coraxReferenceChangesPayload))
      payload2["dataConditions"]["conditions"][0]["fieldValue"] = issues
      let date = document.getElementById("export-drpdwn").value
      if(date == "All"){
        payload["dateConditions"][0]["startDate"] = this.selectedDate
        payload["dateConditions"][0]["endDate"] = this.todayDate
        payload["dateConditions"][1]["startDate"] = this.selectedDate
        payload["dateConditions"][1]["endDate"] = this.todayDate
        payload2["dateConditions"][0]["startDate"] = this.selectedDate
        payload2["dateConditions"][0]["endDate"] = this.todayDate
        payload2["dateConditions"][1]["startDate"] = this.selectedDate
        payload2["dateConditions"][1]["endDate"] = this.todayDate
      }else{
        let d = new Date(date)
        let dateString =  d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
        payload["dateConditions"][0]["startDate"] = dateString
        payload["dateConditions"][0]["endDate"] = dateString
        payload["dateConditions"][1]["startDate"] = dateString
        payload["dateConditions"][1]["endDate"] = dateString
        payload2["dateConditions"][0]["startDate"] = dateString
        payload2["dateConditions"][0]["endDate"] = dateString
        payload2["dateConditions"][1]["startDate"] = dateString
        payload2["dateConditions"][1]["endDate"] = dateString
      }
      this.refPromise = 2
      Promise.all([this.postQueryExecution(payload), this.postQueryExecution(payload2)])
    },
    exportProcessedCoraxEvents(issues,quotes){
      this.requestType = "exportProcessedCoraxEvents"
      var payload = JSON.parse(JSON.stringify(coraxEventsPayload))
      payload["dataConditions"]["conditions"][0]["fieldValue"] = issues
      payload["dataConditions"]["conditions"][1]["fieldValue"] = quotes
      var payload2 = JSON.parse(JSON.stringify(coraxEventsChangesPayload))
      payload2["dataConditions"]["conditions"][0]["fieldValue"] = issues
      let date = document.getElementById("export-drpdwn").value
      if(date == "All"){
        payload["dateConditions"][0]["startDate"] = this.selectedDate
        payload["dateConditions"][0]["endDate"] = this.todayDate
        payload2["dateConditions"][0]["startDate"] = this.selectedDate
        payload2["dateConditions"][0]["endDate"] = this.todayDate
        payload2["dateConditions"][1]["startDate"] = this.selectedDate
        payload2["dateConditions"][1]["endDate"] = this.todayDate
      }else{
        let d = new Date(date)
        let dateString =  d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
        payload["dateConditions"][0]["startDate"] = dateString
        payload["dateConditions"][0]["endDate"] = dateString
        payload2["dateConditions"][0]["startDate"] = dateString
        payload2["dateConditions"][0]["endDate"] = dateString
        payload2["dateConditions"][1]["startDate"] = dateString
        payload2["dateConditions"][1]["endDate"] = dateString
      }
      this.refPromise = 2
      Promise.all([this.postQueryExecution(payload), this.postQueryExecution(payload2)])
    },
    exportDeltaCoraxReference(issues){
      this.requestType = "exportDeltaCoraxReference"
      var payload = JSON.parse(JSON.stringify(coraxReferenceChangesPayload))
      payload["dataConditions"]["conditions"][0]["fieldValue"] = issues
      let date = document.getElementById("export-drpdwn").value
      if(date == "All"){
        payload["dateConditions"][0]["startDate"] = this.selectedDate
        payload["dateConditions"][0]["endDate"] = this.todayDate
        payload["dateConditions"][1]["startDate"] = this.selectedDate
        payload["dateConditions"][1]["endDate"] = this.todayDate
      }else{
        let d = new Date(date)
        let dateString =  d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
        payload["dateConditions"][0]["startDate"] = dateString
        payload["dateConditions"][0]["endDate"] = dateString
        payload["dateConditions"][1]["startDate"] = dateString
        payload["dateConditions"][1]["endDate"] = dateString
      }
      this.postQueryExecution(payload)
    },
    exportDeltaCoraxEvents(issues){
      this.requestType = "exportDeltaCoraxEvents"
      var payload = JSON.parse(JSON.stringify(coraxEventsChangesPayload))
      payload["dataConditions"]["conditions"][0]["fieldValue"] = issues
      let date = document.getElementById("export-drpdwn").value
      if(date == "All"){
        payload["dateConditions"][0]["startDate"] = this.selectedDate
        payload["dateConditions"][0]["endDate"] = this.todayDate
        payload["dateConditions"][1]["startDate"] = this.selectedDate
        payload["dateConditions"][1]["endDate"] = this.todayDate
      }else{
        let d = new Date(date)
        let dateString =  d.getFullYear() + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
        payload["dateConditions"][0]["startDate"] = dateString
        payload["dateConditions"][0]["endDate"] = dateString
        payload["dateConditions"][1]["startDate"] = dateString
        payload["dateConditions"][1]["endDate"] = dateString
      }
      this.postQueryExecution(payload)
    },
    exportPricingData(vals){
      this.requestType = "exportPricing"
      var payload = JSON.parse(JSON.stringify(pricePayload))
      const end = new Date();
      end.setDate(end.getDate() - 2)
      const start = new Date();
      start.setDate(start.getDate() - 11)
      payload["dataConditions"]["conditions"][0]["fieldValue"] = vals
      payload["dateConditions"][0]["startDate"] = start.toJSON().slice(0, 10);
      payload["dateConditions"][0]["endDate"] = end.toJSON().slice(0, 10);
      var payload2 = JSON.parse(JSON.stringify(pricePayload))
      const end2 = new Date();
      end2.setDate(end2.getDate() - 12)
      const start2 = new Date();
      start2.setDate(start2.getDate() - 21)
      payload2["dataConditions"]["conditions"][0]["fieldValue"] = vals
      payload2["dateConditions"][0]["startDate"] = start2.toJSON().slice(0, 10);
      payload2["dateConditions"][0]["endDate"] = end2.toJSON().slice(0, 10);
      this.promiseFlag = 2
      Promise.all([this.postQueryExecution(payload), this.postQueryExecution(payload2)])
    }
}